import React from 'react';

import { Direction } from '@prisjakt/ui';

import ApplyButton from './components/apply-button';
import { OverlayWrapper, OverlayView } from './components/overlay';

import * as S from './styles';

type Props = {
  allSections?: React.ReactNode;
  canClear?: boolean;
  clearFilter: () => void;
  count?: number;
  currentSection: React.ReactNode;
  hasFiltered?: boolean;
  isSearching?: boolean;
  onBack: () => void;
  onClose: () => void;
  searchInput?: React.ReactNode;
  sectionGroups?: React.ReactNode;
  sectionItems: React.ReactNode;
  showBackArrow?: boolean;
  showInitialView?: boolean;
  title: string;
};

export const FilterOverlay = (props: Props) => {
  const {
    allSections,
    canClear = false,
    clearFilter,
    count = 0,
    currentSection,
    hasFiltered = false,
    isSearching = false,
    onBack,
    onClose,
    searchInput,
    sectionGroups,
    sectionItems,
    showBackArrow = false,
    showInitialView = true,
    title,
  } = props;

  return (
    <OverlayWrapper
      applyButton={
        <ApplyButton
          count={count}
          hasFiltered={hasFiltered}
          onClick={onClose}
          onClear={clearFilter}
          canClear={canClear}
        />
      }
      onBack={onBack}
      onClose={onClose}
      showBackArrow={showBackArrow}
      title={title}
    >
      <OverlayView visible={showInitialView} slideDirection={Direction.Left}>
        <S.FilterSectionButtonList>
          {Boolean(allSections) && searchInput}
          {isSearching && Boolean(allSections) ? (
            allSections
          ) : (
            <>
              {sectionItems} {sectionGroups}
            </>
          )}
        </S.FilterSectionButtonList>
      </OverlayView>

      <OverlayView visible={!showInitialView} slideDirection={Direction.Right}>
        {currentSection}
      </OverlayView>
    </OverlayWrapper>
  );
};
